import React from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { ActionMeta, Props } from 'react-select';
import _ from 'lodash';
import { ControllStatus, controllStatusOptions } from 'src/api/types';
import { HintableOption, OptionWithHint } from 'src/components/form/Select/comps';
import { LABELS } from '../labels';

const optionsWithHints: HintableOption[] = controllStatusOptions.map((o) => {
  let hint = '';
  switch (o.value) {
    case ControllStatus.NotStarted:
      hint = LABELS.controlStatusNotStarted;
      break;
    case ControllStatus.InProgress:
      hint = LABELS.controlStatusInProgress;
      break;
    case ControllStatus.Live:
      hint = LABELS.controlStatusLive;
      break;
    case ControllStatus.Abandoned:
      hint = LABELS.controlStatusAbandoned;
      break;
    case ControllStatus.Retired:
      hint = LABELS.controlStatusRetired;
      break;
    case ControllStatus.NotApplicable:
      hint = LABELS.controlStatusNotApplicable;
      break;
  }
  return {
    ...o,
    hint,
  };
});

interface ControlStatusSelectProps extends Omit<Props, 'value'> {
  value: string | undefined | null;
  onChange: (value: { label: string; value: string }, meta: ActionMeta<any>) => void;
  onBlur?: () => void;
  error?: boolean;
  helperText?: string | false;
  disabled?: boolean;
  placeholder?: string;
}

export const ControlStatusSelect: React.FC<ControlStatusSelectProps> = ({
  value,
  onChange,
  onBlur,
  error,
  helperText,
  disabled,
  placeholder = 'Select status',
}) => {
  return (
    <>
      <CSelect
        isDisabled={disabled}
        value={_.find(optionsWithHints, (o) => o.value === value)}
        placeholder={placeholder}
        options={optionsWithHints}
        onChange={onChange}
        onBlur={onBlur}
        inputId="status-select"
        components={{ Option: OptionWithHint }}
      />
      {error && helperText && <Error>{helperText}</Error>}
    </>
  );
};
